import React from "react";

import WidgetsDropdown from "./widgets/WidgetsDropdown";
// import MainChart from "./MainChart";

const Dashboard = () => {
 

  return (
    <>
      <WidgetsDropdown className="mb-4" />
   
    </>
  );
};

export default Dashboard;
